module.exports = "images/france-3.be482384.png";